<template>
  <!-- Android SendProposalDialogue (BOOKING): email the evaluation report -->
  <div ref="modal" class="modal fade fxModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 440px">
      <div class="modal-content">
        <div class="modal-body p-[20px] font-roboto">
          <FxModalHeader title="Send Proposal" :dismiss="false" @close="close" />
          <label class="block m-0 mt-[15px]">
            <span class="block mb-[5px] text-[13px] font-medium text-[#333333]">Email</span>
            <input v-model.trim="email" type="email" placeholder="Enter email address"
              class="w-full px-[12px] py-[10px] rounded-[10px] border-1 outline-none text-[14px] text-[#333333]"
              :class="error ? 'border-[#F67280] bg-[#FEF7F7]' : 'border-[#EFEFEF]'" @keyup.enter="submit">
            <span v-if="error" class="block mt-[4px] text-[12px] text-[#EA8A8A]">{{ error }}</span>
          </label>
          <div class="flex justify-center gap-[10px] mt-[20px]">
            <button type="button" class="fxDeclineCancel" @click="close">Cancel</button>
            <button type="button" class="fxBtnPrimary" :disabled="busy" @click="submit">Send</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import FxModalHeader from "../nest_components/FxModalHeader.vue";
import { bookingActionsApi } from "../../services/bookingActionsApi";
import { evaluationApi } from "../../services/evaluationApi";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  components: { FxModalHeader },
  props: {
    bookingId: { type: [String, Number], required: true },
    // View Evaluation (G-70): () => Promise<File> — the app's quote PDF, emailed via summary/quote/pdf/send;
    // without it the booking's proposal is sent as before (bookings/send-proposal)
    pdf: { type: Function, default: null },
  },
  emits: ["sent", "failed"],
  data() {
    return { email: "", error: "", busy: false };
  },
  beforeUnmount() {
    Modal.getInstance(this.$refs.modal)?.dispose();
  },
  methods: {
    open(email) {
      this.email = email || "";
      this.error = "";
      Modal.getOrCreateInstance(this.$refs.modal).show();
    },
    close() {
      Modal.getInstance(this.$refs.modal)?.hide();
    },
    async submit() {
      if (!this.email) { this.error = "This field is required."; return; }
      if (!EMAIL_RE.test(this.email)) { this.error = "Please enter a valid email address."; return; }
      this.error = "";
      this.busy = true;
      let res;
      try {
        res = this.pdf
          ? await evaluationApi.sendQuotePdf(this.bookingId, this.email, await this.pdf())
          : await bookingActionsApi.sendProposal(this.bookingId, this.email);
      } catch (e) {
        res = { ok: false, message: "Unable to create the quote PDF." };
      }
      this.busy = false;
      if (res.ok) {
        this.close();
        this.$emit("sent", res);
      } else {
        if (res.activeRecord) this.close();
        this.$emit("failed", res);
      }
    },
  },
};
</script>
